"use strict";

var _classCallCheck = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/classCallCheck");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @hidden
 * Internal representation of an Ethereum wallet
 */

var Wallet = // eslint-disable-next-line require-jsdoc
function Wallet(_ref) {
  var address = _ref.address;

  _classCallCheck(this, Wallet);

  this.address = address;
};

exports.Wallet = Wallet;